import remember from './remember';
import fetchJsonFromRpgLogsApi from './fetchJsonFromRpgLogsApi';
import type GoogleAnalyticsViewModel from '../../resources/js/typings/viewModels/googleAnalyticsViewModel';
import { type ArchonHeaderViewModel } from '../components/ArchonHeader/ArchonHeader';
import { type ArchonFooterViewModel } from '../components/ArchonFooter/ArchonFooter';
import { type AdPlacementsViewModel } from '@resources/js/typings/viewModels/adPlacements';
import { type PlaywireAdsViewModel } from '@resources/js/contexts/usePlaywire';

export type CommonViewModels = {
  googleAnalytics: GoogleAnalyticsViewModel;
  adPlacements: AdPlacementsViewModel;
  playwireAds: PlaywireAdsViewModel;
  header: ArchonHeaderViewModel;
  footer: ArchonFooterViewModel;
};

export default function getCommonViewModels(
  gameSlug: string | null = null,
  locale: string | null = null,
): Promise<CommonViewModels> {
  return remember(
    `getCommonViewModels-${gameSlug}${locale ? `-${locale}` : ''}-v13`,
    600,
    async () => {
      const data = await fetchJsonFromRpgLogsApi({
        query: `query($gameSlug: String, $locale: String) {
      viewModels {
        googleAnalytics
        adPlacements
        playwireAds
        header(gameSlug: $gameSlug, locale: $locale)
        footer(gameSlug: $gameSlug)
      }
    }`,
        variables: {
          gameSlug,
          locale,
        },
        gameSlug,
        locale,
      });

      return data.viewModels;
    },
  );
}
